import { tracker } from '@kueski-dev/web-observability';
import { AMPLITUDE_KUESKI } from 'Src/consts/observabilityTargets';

export const sendCreateNewAccountClicked = () => {
  tracker.track('button_clicked', {
    attributes: { button_name: 'create_new_account' },
    customAttributes: {
      origin_screen: 'email_verification',
    },
    target: AMPLITUDE_KUESKI,
  });
};

export const sendCheckVerifiedClicked = () => {
  tracker.track('button_clicked', {
    attributes: { button_name: 'verified_email' },
    customAttributes: {
      origin_screen: 'email_verification',
    },
    target: AMPLITUDE_KUESKI,
  });
};
